import React from 'react';

const Logo = ({ variant = 'full', className = '', size = 'default' }) => {
  const sizes = {
    small: { bars: [12, 18, 24], gap: 2, text: 'text-base', sub: 'text-[8px] tracking-[2px]' },
    default: { bars: [14, 22, 30], gap: 2, text: 'text-lg', sub: 'text-[9px] tracking-[3px]' },
    large: { bars: [18, 28, 38], gap: 3, text: 'text-xl', sub: 'text-[10px] tracking-[4px]' }
  };

  const s = sizes[size] || sizes.default;

  // Logo Icon - Three ascending bars
  const LogoIcon = ({ color = 'var(--navy-primary)' }) => (
    <div className="flex items-end" style={{ gap: `${s.gap}px` }}>
      <div 
        className="rounded-sm"
        style={{ 
          width: `${s.bars[0] * 0.5}px`,
          height: `${s.bars[0]}px`, 
          backgroundColor: color 
        }} 
      />
      <div 
        className="rounded-sm"
        style={{ 
          width: `${s.bars[1] * 0.5}px`,
          height: `${s.bars[1]}px`, 
          backgroundColor: color 
        }} 
      />
      <div 
        className="rounded-sm"
        style={{ 
          width: `${s.bars[2] * 0.5}px`,
          height: `${s.bars[2]}px`, 
          backgroundColor: color 
        }} 
      />
    </div>
  );

  // Text component
  const LogoText = ({ color = 'var(--navy-primary)' }) => (
    <div className="flex flex-col leading-none">
      <span 
        className={`font-bold ${s.text}`}
        style={{ color, letterSpacing: '0.5px' }}
      >
        GRUPO SANTANA
      </span>
      <span 
        className={`font-normal uppercase ${s.sub} mt-0.5`}
        style={{ color, opacity: 0.7 }}
      >
        Home Services
      </span>
    </div>
  );

  if (variant === 'icon') {
    return (
      <div className={`flex items-center ${className}`}>
        <LogoIcon />
      </div>
    );
  }

  if (variant === 'white') {
    return (
      <div className={`flex items-center gap-2.5 ${className}`}>
        <LogoIcon color="white" />
        <LogoText color="white" />
      </div>
    );
  }

  // Full variant - horizontal
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoIcon />
      <LogoText />
    </div>
  );
};

export default Logo;
